module.exports = __webpack_public_path__ + "static/media/youtube.4787efc6.svg";